import {
  SEARCH_CARE_PLAN_TEAM,
  SEARCH_CARE_PLAN_TEAM_SUCCESS,
  SEARCH_CARE_PLAN_TEAM_FAILURE,
  FETCH_CARE_PLAN_TEAM,
  FETCH_CARE_PLAN_TEAM_SUCCESS,
  FETCH_CARE_PLAN_TEAM_FAILURE,
  ADD_CARE_PLAN_TEAM,
  ADD_CARE_PLAN_TEAM_SUCCESS,
  ADD_CARE_PLAN_TEAM_FAILURE,
  FETCH_CARE_PLAN_TEAM_MEMBER,
  FETCH_CARE_PLAN_TEAM_MEMBER_SUCCESS,
  FETCH_CARE_PLAN_TEAM_MEMBER_FAILURE,
  EDIT_CARE_PLAN_TEAM,
  EDIT_CARE_PLAN_TEAM_SUCCESS,
  EDIT_CARE_PLAN_TEAM_FAILURE,
  DELETE_CARE_PLAN_TEAM,
  DELETE_CARE_PLAN_TEAM_SUCCESS,
  DELETE_CARE_PLAN_TEAM_FAILURE,
  SET_CARE_PLAN_TEAM_ADD_EDIT_MODAL,
} from "./constants";

export const searchCarePlanTeam = (payload) => ({
  type: SEARCH_CARE_PLAN_TEAM,
  payload,
});
export const searchCarePlanTeamSuccess = (payload) => ({
  type: SEARCH_CARE_PLAN_TEAM_SUCCESS,
  payload,
});
export const searchCarePlanTeamFailure = (payload) => ({
  type: SEARCH_CARE_PLAN_TEAM_FAILURE,
  payload,
});

export const fetchCarePlanTeam = (payload) => ({
  type: FETCH_CARE_PLAN_TEAM,
  payload,
});
export const fetchCarePlanTeamSuccess = (payload) => ({
  type: FETCH_CARE_PLAN_TEAM_SUCCESS,
  payload,
});
export const fetchCarePlanTeamFailure = (payload) => ({
  type: FETCH_CARE_PLAN_TEAM_FAILURE,
  payload,
});

export const addCarePlanTeam = (payload) => ({
  type: ADD_CARE_PLAN_TEAM,
  payload,
});
export const addCarePlanTeamSuccess = (payload) => ({
  type: ADD_CARE_PLAN_TEAM_SUCCESS,
  payload,
});
export const addCarePlanTeamFailure = (payload) => ({
  type: ADD_CARE_PLAN_TEAM_FAILURE,
  payload,
});

export const fetchCarePlanTeamMember = (payload) => ({
  type: FETCH_CARE_PLAN_TEAM_MEMBER,
  payload,
});
export const fetchCarePlanTeamMemberSuccess = (payload) => ({
  type: FETCH_CARE_PLAN_TEAM_MEMBER_SUCCESS,
  payload,
});
export const fetchCarePlanTeamMemberFailure = (payload) => ({
  type: FETCH_CARE_PLAN_TEAM_MEMBER_FAILURE,
  payload,
});

export const editCarePlanTeam = (payload) => ({
  type: EDIT_CARE_PLAN_TEAM,
  payload,
});
export const editCarePlanTeamSuccess = (payload) => ({
  type: EDIT_CARE_PLAN_TEAM_SUCCESS,
  payload,
});
export const editCarePlanTeamFailure = (payload) => ({
  type: EDIT_CARE_PLAN_TEAM_FAILURE,
  payload,
});

export const deleteCarePlanTeam = (payload, onDelete) => ({
  type: DELETE_CARE_PLAN_TEAM,
  payload,
  onDelete,
});
export const deleteCarePlanTeamSuccess = (payload) => ({
  type: DELETE_CARE_PLAN_TEAM_SUCCESS,
  payload,
});
export const deleteCarePlanTeamFailure = (payload) => ({
  type: DELETE_CARE_PLAN_TEAM_FAILURE,
  payload,
});

export const setCarePlanTeamAddEditModal = (payload) => ({
  type: SET_CARE_PLAN_TEAM_ADD_EDIT_MODAL,
  payload,
});
